
export const AUTHORIZE_USER = 'AUTHORIZE_USER';
export const LOGOUT = 'LOGOUT';
export const CLEAN_THINGS = 'CLEAN_THINGS';
export const TEMPORARY_SAVE_SOMTHING = 'TEMPORARY_SAVE_SOMTHING';
export const CHNANGE_TAB = 'CHNANGE_TAB';
export const CHNANGE_LISTVIEW_TAB = 'CHNANGE_LISTVIEW_TAB';
